import React from 'react';

interface PropTypes {
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  icon: React.ReactNode;
  label: string;
  className?: string;
}

const ButtonWithLabel: React.FC<PropTypes> = ({
  label,
  icon,
  className,
  onClick
}) => {
  return (
    <button
      className={`flex flex-col items-center justify-center ${className}`}
      onClick={onClick}
    >
      {icon}
      <span className="text-white mt-1">{label}</span>
    </button>
  );
};

export default ButtonWithLabel;
